// A scanned device QR code's pairing code (card 540f21a4): read from /pair's
// address and kept in sessionStorage while the admin signs in.
const CODE_KEY = 'feislink.pair.code';
const digitsOf = (v) => {
  const d = String(v || '').replace(/[^0-9]/g, '');
  return d.length === 6 ? d : '';
};

// The code in the address, else the one kept while signing in.
export function pairCodeFrom(search) {
  const fromUrl = digitsOf(new URLSearchParams(search).get('code'));
  try {
    if (fromUrl) sessionStorage.setItem(CODE_KEY, fromUrl);
    return fromUrl || digitsOf(sessionStorage.getItem(CODE_KEY));
  } catch (e) {
    return fromUrl;
  }
}
// After signing in: back to /pair when a scanned code is waiting.
export const pairCodeWaiting = () => {
  try {
    return !!digitsOf(sessionStorage.getItem(CODE_KEY));
  } catch (e) {
    return false;
  }
};
export const forgetPairCode = () => {
  try {
    sessionStorage.removeItem(CODE_KEY);
  } catch (e) {
    // nothing kept
  }
};
